import { useRef, useState } from 'react';
import api from '../services/api';

/**
 * Consulta de CEP. `onFound({ street, neighborhood, city, state })` recebe o endereço retornado.
 * `handleCepChange(valor)` deve ser chamado a cada alteração do campo de CEP.
 */
export default function useCepLookup(onFound) {
    const [cepLoading, setCepLoading] = useState(false);
    const [cepError, setCepError] = useState('');
    const lastLookupRef = useRef('');

    const lookupCep = async (cep) => {
        if (cep.length !== 8 || lastLookupRef.current === cep) return;
        lastLookupRef.current = cep;
        setCepLoading(true);
        setCepError('');
        try {
            const response = await api.get(`/cep/${cep}`);
            onFound(response.data || {});
        } catch (e) {
            setCepError(e.response?.status === 404 ? 'CEP não encontrado' : 'Não foi possível consultar o CEP');
        } finally {
            setCepLoading(false);
        }
    };

    const handleCepChange = (value) => {
        const digits = (value || '').replace(/\D/g, '');
        if (digits.length === 8) {
            lookupCep(digits);
        } else {
            setCepError('');
        }
    };

    return { cepLoading, cepError, handleCepChange };
}
